var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7 12h10","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

Minus.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Minus;

Minus.default = Minus;
